/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 29/07/2025.
 */

import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { getReq } from '../service/API'

/**
 *
 * Evaluate if the particioant has recently done a sync of data from the device.
 *
 */
export const useSyncEvaluator = (projectId, subjectId) => {
  const path = ENDPOINTS.SUBJECTS.getSubjectSyncEvaluation(projectId, subjectId)

  const { data, mutate, error } = useSWR(path, getReq, {
    suspense: true,
    /*revalidateOnMount: true,
    revalidateIfStale: true,
    focusThrottleInterval: 1,*/
  })

  return {
    data: !data ? null : data?.data,
    mutate: mutate,
    isLoading: !error && !data,
    isError: error,
    path: path,
  }
}
